import React, { useState } from "react";
import { Link } from "react-router-dom";
import NotificationBanner from "./NotificationBanner";
import {
  getActiveNotifications,
  isNotificationDismissed,
} from "../utils/notifications";
import { useEffect } from "react";

const PublicNav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [visibleNotifications, setVisibleNotifications] = useState([]);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    const result = await getActiveNotifications();
    if (result.success && result.data) {
      // Filter out dismissed notifications
      const visible = result.data.filter(
        (notification) => !isNotificationDismissed(notification.id)
      );
      setVisibleNotifications(visible);
    }
  };

  const navLinks = [
    { name: "الرئيسية", href: "/#" },
    { name: "متطلبات التسليم", href: "/submission-requirements" },
    { name: "الجدول الزمني", href: "/#timeline" },
    { name: "الأسئلة الشائعة", href: "/#faq" },
  ];

  const handleSmoothScroll = (e, href) => {
    // Only handle internal hash links
    if (href.startsWith("/#")) {
      const targetId = href.substring(2); // Remove '/#'
      const targetElement = targetId
        ? document.getElementById(targetId)
        : document.body;

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setIsMenuOpen(false);
    }
  };

  return (
    <>
    {visibleNotifications.length > 0 && (
      // add transparent padding top to the nav
      <div className="pt-10">
      </div>
    )}
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/5 backdrop-blur-md border-b border-white/10">
      <NotificationBanner />
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              alt="Qimma Logo"
              className="w-12 h-12 group-hover:scale-110 transition-transform "
            />
            <span className="text-2xl font-semibold text-white hidden sm:block">
              قمة هاكاثون
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link, index) =>
              link.href.startsWith("/#") ? (
                <a
                  key={index}
                  href={link.href}
                  onClick={(e) => handleSmoothScroll(e, link.href)}
                  className="text-white/80 hover:text-yellow font-medium transition-colors relative group"
                >
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow group-hover:w-full transition-all"></span>
                </a>
              ) : (
                <Link
                  key={index}
                  to={link.href}
                  className="text-white/80 hover:text-yellow font-medium transition-colors relative group"
                >
                  {link.name}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow group-hover:w-full transition-all"></span>
                </Link>
              )
            )}
            <Link
              to="/certificate"
              className="px-6 py-2.5 bg-yellow text-blue font-semibold rounded-lg hover:bg-yellow transition-all  hover:scale-105"
            >
              إستلام الشهادة
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-white p-2"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-3 border-t border-white/10">
            <div className="flex flex-col gap-4">
              {navLinks.map((link, index) =>
                link.href.startsWith("/#") ? (
                  <a
                    key={index}
                    href={link.href}
                    onClick={(e) => handleSmoothScroll(e, link.href)}
                    className="text-white/80 hover:text-yellow font-medium transition-colors text-right py-2"
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={index}
                    to={link.href}
                    onClick={() => setIsMenuOpen(false)}
                    className="text-white/80 hover:text-yellow font-medium transition-colors text-right py-2"
                  >
                    {link.name}
                  </Link>
                )
              )}
              <Link
                to="/certificate"
                onClick={() => setIsMenuOpen(false)}
                className="px-6 py-2.5 bg-yellow text-blue font-semibold rounded-lg hover:bg-yellow transition-all  text-center"
              >
                إستلام الشهادة
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
    </>
  );
};

export default PublicNav;
